const isDemo = process.env.REACT_APP_DEMO_MODE === "true";

export const api = (url, params, callback) => {
  if (!isDemo) {
    fetch("/" + url, {
      headers: {
        "Content-Type": "application/json",
      },
      method: "POST",
      body: JSON.stringify(params),
    })
      .then((response) => response.json())
      .then((data) => callback(data));
  } else {
    return require("./demo.json");
  }
};
